///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/point-promotions.filter.ts"/>
///<reference path="../collections/report-users.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class TextelEmployeesWithCategoriesDataTemplate extends DataTemplateBase implements IDataTemplate {
        protected employeeCategories: EmployeeCategoriesCollection;
        protected employees: TextelEmployeesCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.employeeCategories;
        }

        get leafCollection() {
            return this.employees;
        }

        reconnectLeafCollectionModel(model) {
            this.leafCollection.connectedModel = model[this.properties[1]];
        }

        get totalSelectedCount(): number {
            return this.employees.value.length;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.employeeCategories = new EmployeeCategoriesCollection(this.model[properties[0]], [], {
                criteria: options.criteria
            });
            this.employees = new TextelEmployeesCollection(this.model[properties[1]], [], {
                criteria: options.criteria
            });
            this.employees.setParentCollection(this.employeeCategories, EmployeeToCategoriesStrategy);

            this.filters = [
                new ActiveInactiveFilter({ hideInactiveLabel: 'LABEL_HIDE_INACTIVE_EMPLOYEES' }, this)
            ];
            this.employees.addFilters(...this.filters as IInteractiveFilter[]);

            this.title = 'LABEL_EMPLOYEE';
            this.allSelectedLabel = 'LABEL_ALL_EMPLOYEES_UPPER';
            this.totalSelectedMessage = 'LABEL_TOTAL_EMPLOYEES_SELECTED';
        }

        setWatchers(scope: angular.IScope) {
            super.setWatchers(scope);

            this.employees.setWatchers(scope);
        }
    }
}
